import { type StateCreator } from 'zustand';
import { type Shortcut, type ShortcutsStore, type State, type Store } from './types.ts';

export const createShortcutsStore: (initialState: Partial<State>) => StateCreator<Store, [], [], ShortcutsStore> =
  initialState => (set, get) => ({
    addShortcut: (shortcut: Shortcut) => {
      const { shortcuts } = get();

      if (shortcuts.some(entry => entry.label === shortcut.label)) {
        return;
      }

      set(state => ({
        shortcuts: [shortcut, ...state.shortcuts],
      }));
    },
    getShortcuts: () => {
      return [...get().shortcuts];
    },
    hasShortcuts: () => {
      return get().shortcuts.length > 0;
    },
    removeShortcut: (label: string) => {
      const { shortcuts } = get();

      if (!shortcuts.some(entry => entry.label === label)) {
        return;
      }

      set(state => {
        const index = state.shortcuts.findIndex(entry => entry.label === label);
        const newShortcuts = state.shortcuts.toSpliced(index, 1);

        return {
          shortcuts: newShortcuts,
        };
      });
    },
    shortcuts: initialState.shortcuts ?? [],
  });
